export default "__VITE_ASSET__1482f21c__"